<template>
  <div class="opc-zm-base-card__head">
    <div class="opc-zm-base-card__head-left">
      <img class="opc-zm-base-card__logo" :src="logo" alt="" tabindex="-1" />
    </div>
    <div class="opc-zm-base-card__head-right">
      <div class="opc-zm-base-card__head-right-content">
        <h2 class="opc-zm-base-card__name text-capitalize">
          {{ title }}
        </h2>
        <slot name="head-right-content" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
      default: () => "",
    },
    title: String,
    ready: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
